
export default function CachePromise () {
    const promiseCache = {};

    return function ( name, fn ) {
        // if the function has been run return the existing promise
        // otherwise run the function and return the result
        return async () => {
            if ( !promiseCache[ name ] ) {
                promiseCache[ name ] = fn();
            }
            return promiseCache[ name ];
        };
    };
}
